import { useRouterState } from '@tanstack/react-router'
import { useEffect, useRef, useState } from 'react'
import type { JSX } from 'react'

export function NavigationProgress(): JSX.Element {
  const isLoading = useRouterState({ select: (s) => s.status === 'pending' })

  const [progress, setProgress] = useState(0)
  const [opacity, setOpacity] = useState(0)
  const tickRef = useRef<ReturnType<typeof setInterval> | null>(null)

  useEffect(() => {
    if (isLoading) {
      setOpacity(1)
      setProgress(8)

      tickRef.current = setInterval(() => {
        setProgress((p) => (p >= 82 ? p : p + (82 - p) * 0.12))
      }, 160)

      return () => {
        if (tickRef.current !== null) clearInterval(tickRef.current)
      }
    }

    if (tickRef.current !== null) clearInterval(tickRef.current)

    setProgress(100)
    const t1 = setTimeout(() => setOpacity(0), 200)
    const t2 = setTimeout(() => setProgress(0), 600)

    return () => {
      clearTimeout(t1)
      clearTimeout(t2)
    }
  }, [isLoading])

  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed left-0 top-0 z-[100] h-[5px] bg-primary dark:bg-foreground transition-[width,opacity] duration-300 ease-out"
      style={{ width: `${progress}%`, opacity }}
    />
  )
}
